const initialState = {

    states: {},
  }
  
  const coupon = (state = initialState, action) => {
    switch (action.type) {
  
      case 'SET_SAVE_COUPON_RESPONSE':
        return {
          ...state,
          showCreateView : true,
          showCouponListView : false,
          success: action.response.success,
          couponSaveResponse : action.response
        }
      
      case 'SET_NULL_PROPS_RESPONSE':
       return{
        ...state,
        success: false,
        couponSaveResponse:false
       }

      case 'SET_COUPONS_LIST':
       return{
         ...state,
         showCreateView : false,
         showCouponListView : true,
         couponListSuccess : action.responseData.success,
         couponListData : action.responseData
       }

       case 'VIEW_CREATE_COUPON':
        return{
          ...state,
          showCreateView : true,
          showCouponListView : false,
        }
  
      default:
        return state;
    }
  };
  export default coupon;
  


// WEBPACK FOOTER //
// ./src/reducers/coupon.js